import React, {useMemo, memo} from 'react';
import PropTypes from 'prop-types';
import {t} from '../../services/i18nHandler';
import {USER_ROLE} from '../../constants/user';
import PageTabs from '../PageTabs';

const TariffsRoleSwitch = ({
  activeRole, onClick, disabled, landing, userRole,
}) => {
  const roles = useMemo(() => {
    const employer = {
      label: 'plans.forEmployers',
      value: USER_ROLE.EMPLOYER,
    };
    const candidate = {
      label: 'plans.forCandidates',
      value: USER_ROLE.CANDIDATE,
    };
    const agency = {
      label: 'plans.forAgency',
      value: USER_ROLE.RECRUITER,
    };
    if (landing) {
      return [
        candidate,
        employer,
        agency,
      ];
    }
    if (userRole === USER_ROLE.CANDIDATE) {
      return [candidate];
    }
    if (userRole === USER_ROLE.EMPLOYER) {
      return [employer];
    }
    if (userRole === USER_ROLE.RECRUITER) {
      return [agency];
    }
    return [candidate, employer, agency];
  }, [userRole]);

  if (!landing) {
    return (
      <PageTabs
        data={roles}
        activeTab={activeRole}
        onClick={onClick}
      />
    );
  }

  return (
    <div className={`tariffs_role-switch ${disabled ? 'disabled' : ''}`}>
      <div className="tariffs_role-switch_inner">
        {roles.map((role) => (
          <span
            key={role.value}
            className={`tariffs_role-switch_item ${activeRole === role.value ? 'active' : ''}`}
            onClick={disabled ? null : () => onClick(role.value)}
          >
            {t(role.label)}
          </span>
        ))}
      </div>
    </div>
  );
};

TariffsRoleSwitch.defaultProps = {
  activeRole: USER_ROLE.CANDIDATE,
  onClick: () => {},
  disabled: false,
};

TariffsRoleSwitch.propTypes = {
  activeRole: PropTypes.number,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default memo(TariffsRoleSwitch);
